import { render, staticRenderFns } from "./ListExpansionPanels.vue?vue&type=template&id=63f96788&scoped=true&"
import script from "./ListExpansionPanels.vue?vue&type=script&lang=js&"
export * from "./ListExpansionPanels.vue?vue&type=script&lang=js&"
import style0 from "./ListExpansionPanels.vue?vue&type=style&index=0&id=63f96788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f96788",
  null
  
)

export default component.exports